/**
 * @generated SignedSource<<48ea0424944cd7db29b00939540dcf22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUpdateShipmentQuote_transaction$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "useUpdateShipmentQuote_transaction";
};
export type useUpdateShipmentQuote_transaction$key = {
  readonly " $data"?: useUpdateShipmentQuote_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUpdateShipmentQuote_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUpdateShipmentQuote_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "5384fb6b8a42d27a259a1206549a2a81";

export default node;
